import React from "react"
import ContentLoader from "react-content-loader"

export default function LoadingPlaceholder() {
  return (
    <ContentLoader viewBox="0 0 380 700">
      <rect x="292" y="7" rx="5" ry="5" width="80" height="80"/>
      <rect x="130" y="10" rx="4" ry="4" width="150" height="13"/>

      <rect x="292" y="112" rx="10" ry="10" width="80" height="80"/>
      <rect x="130" y="115" rx="4" ry="4" width="150" height="13"/>

      <rect x="292" y="217" rx="10" ry="10" width="80" height="80"/>
      <rect x="130" y="220" rx="4" ry="4" width="150" height="13"/>

      <rect x="292" y="322" rx="10" ry="10" width="80" height="80"/>
      <rect x="130" y="325" rx="4" ry="4" width="150" height="13"/>

      <rect x="292" y="427" rx="10" ry="10" width="80" height="80"/>
      <rect x="130" y="430" rx="4" ry="4" width="150" height="13"/>

      <rect x="292" y="532" rx="10" ry="10" width="80" height="80"/>
      <rect x="130" y="535" rx="4" ry="4" width="150" height="13"/>
    </ContentLoader>
  )

}
